// This module is not imported by Joy2, because Dialog component is buggy
Hop.defineModule('show-dialog', (root, param) => {
    const $targetDialog = param.target;

    if (!$targetDialog) {
        throw new Error('Missing target parameter for your module');
    }

    function openDialog() {
        root.dispatchEvent(
            new Event(`dialog:show-${$targetDialog}`, {
                bubbles: true,
            }),
        );
    }

    function init() {
        root.addEventListener('click', openDialog);
    }

    init();

    return function destroy() {
        root.removeEventListener('click', openDialog);
    };
});
